(() => {
  const product = document.querySelector('product-info[data-product-id="15398036635700"]');
  if (!product) return;
  const view = new URL(location.href).searchParams.get('view');
  // Shopify's alternate-template preview must survive section rendering requests.
  if (view === 'dc-medit-ie-v2') customElements.whenDefined('product-info').then(() => {
    const build = product.buildRequestUrlWithParams.bind(product);
    product.buildRequestUrlWithParams = (...args) => build(...args) + '&view=dc-medit-ie-v2';
  });
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  product.querySelectorAll('video[autoplay]').forEach(video => {
    video.muted = true;
    if (reduced.matches) { video.pause(); return; }
    // Do not override a deliberate pause or consume bandwidth while off screen.
    let userPaused = false;
    video.addEventListener('pause', () => {
      if (!video.dataset.visibilityPause && !document.hidden) userPaused = true;
    });
    video.addEventListener('play', () => { userPaused = false; });
    const observer = new IntersectionObserver(entries => {
      const visible = entries[0].isIntersecting;
      if (visible && !userPaused) { delete video.dataset.visibilityPause; video.play().catch(() => {}); }
      else if (!visible && !video.paused) { video.dataset.visibilityPause = 'true'; video.pause(); }
    }, {threshold:0.2});
    observer.observe(video);
  });
})();
